import React, { useEffect, useLayoutEffect, useState } from 'react'
import "../../style/loader.css";
import RBloader from "../../assets/image/RB Loader.gif";
import { useLocation } from 'react-router-dom';
import { useShowProfileSideMenu } from '../../includes/profilePageLayout';

const MAIN_SIDEBAR_WIDTH = 98;
const PROFILE_SIDEMENU_WIDTH = 278;

const WALLET_SHOP_ROUTES = [
    '/home/profile/wallet',
    '/home/profile/shop',
];

const isWalletShopRoute = (pathname) =>
    WALLET_SHOP_ROUTES.includes(pathname) ||
    pathname.startsWith('/home/profile/shop/');

const getVisibleSideMenuRect = () => {
    const sideMenu = document.querySelector('.profile-sidemenu-wrap');
    if (!sideMenu) {
        return null;
    }

    const rect = sideMenu.getBoundingClientRect();
    if (rect.width < 10 || rect.height < 10) {
        return null;
    }

    return rect;
};

const getPreloaderStyle = (pathname, showProfileSideMenu) => {
    const sideMenuRect = getVisibleSideMenuRect();

    if (sideMenuRect) {
        const left = Math.round(sideMenuRect.right);
        return {
            position: 'fixed',
            top: 0,
            left: `${left}px`,
            width: `calc(100% - ${left}px)`,
            right: '0',
            height: '96vh',
            zIndex: 100,
            borderRadius: '20px',
        };
    }

    const isProfileRoute = pathname.startsWith('/home/profile');
    const isWalletShop = isWalletShopRoute(pathname);

    if (isWalletShop && !showProfileSideMenu) {
        return {
            left: `${MAIN_SIDEBAR_WIDTH}px`,
            width: `calc(100% - ${MAIN_SIDEBAR_WIDTH}px)`,
            right: '0',
        };
    }

    if (isProfileRoute && showProfileSideMenu) {
        const leftOffset = MAIN_SIDEBAR_WIDTH + PROFILE_SIDEMENU_WIDTH;
        return {
            left: `${leftOffset}px`,
            width: `calc(100% - ${leftOffset}px)`,
            right: '0',
        };
    }

    if (isProfileRoute) {
        return {
            left: `${MAIN_SIDEBAR_WIDTH}px`,
            width: `calc(100% - ${MAIN_SIDEBAR_WIDTH}px)`,
            right: '0',
        };
    }

    return { width: '100%', right: '0' };
};

const Loader = ({ showLoader, contentOnly = false }) => {
    const location = useLocation();
    const showProfileSideMenu = useShowProfileSideMenu();
    const isControlled = showLoader !== undefined;
    const [showInitialLoader, setShowInitialLoader] = useState(!isControlled);
    const [preloaderStyle, setPreloaderStyle] = useState({});

    useEffect(() => {
        if (isControlled) {
            return;
        }

        const timer = setTimeout(() => {
            setShowInitialLoader(false);
        }, 1000);

        return () => clearTimeout(timer);
    }, [isControlled, location.pathname]);

    const isVisible = isControlled ? showLoader : showInitialLoader;

    useLayoutEffect(() => {
        if (!isVisible || contentOnly) {
            return;
        }

        const updateStyle = () => {
            setPreloaderStyle(getPreloaderStyle(location.pathname, showProfileSideMenu));
        };

        updateStyle();
        window.addEventListener('resize', updateStyle);
        return () => window.removeEventListener('resize', updateStyle);
    }, [isVisible, contentOnly, location.pathname, showProfileSideMenu]);

    if (!isVisible) {
        return null;
    }

    if (contentOnly) {
        return (
            <div className="preloader preloader--content">
                <img src={RBloader} alt="Loading" />
                <div className="preloader__text">
                    <p>Please Wait...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="main-section">
            <div className="preloader" style={preloaderStyle}>
                <img src={RBloader} alt="Loading" />
                <div className="preloader__text">
                    <p>Please Wait...</p>
                </div>
            </div>
        </div>
    )
}

export default Loader
